import axios from '@/utils/fetch'
import {VERSION} from '@/apis/config'
const _module = `uc/${VERSION}/verification`;

export default {
    getSms(data){
        return axios({
            url:`${_module}/sms`,
            data,
            method:'POST'
        })
    }
}


// WEBPACK FOOTER //
// ./src/apis/src/uc.js